import styled from 'styled-components';
import { Card } from 'antd';


export const StyledCard1 = styled(Card)`
border: 1px solid #D3D3D3;
border-radius:20px;
margin-bottom: 10px;


box-shadow: 0 8px 6px -6px grey;
`;

export const StyledElogbook = styled.div`
  margin: 45px 0px;
`;
